<template>
  <v-container
    fluid
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      width: '100vw',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
    }"
  >
    <v-layout>
      <v-flex>
        <v-row justify="center" align="center">
          <v-col cols="12" class="d-flex flex-column align-center text-center">
            <v-row justify="center" align="center" class="mt-14 my-8">
              <v-col cols="2" justify="center" align="center" class="pr-0">
                <v-img
                  contain
                  :src="require('@/assets/VP_sin_fondo.png')"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
              <v-col cols="2" justify="center" align="center" class="pl-0">
                <v-img
                  contain
                  src="img/beonit.png"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
            </v-row>

            <v-card class="mt-12 mx-4 pa-6" width="500">
              <v-card-title class="justify-center mb-6">
                <h5>Reset password</h5>
              </v-card-title>

              <v-form
                v-if="
                  token !== null && token !== undefined && token !== 'null' && token !== 'undefined'
                "
                v-model="valid"
                @submit.prevent="resetPassword"
              >
                <v-card-text class="py-0">
                  <v-text-field
                    v-model="password"
                    class="py-0 mb-6 no-border-radius"
                    label="Password"
                    :rules="[passwordRules.required, passwordRules.minLength]"
                    dense
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="togglePasswordVisibility"
                  />
                  <v-text-field
                    v-model="confirmPassword"
                    class="mb-4 no-border-radius"
                    label="Repeat password"
                    :rules="[confirmPasswordRules.required, confirmPasswordRules.passwordMatch]"
                    dense
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="toggleConfirmPasswordVisibility"
                  />
                </v-card-text>

                <v-card-actions class="mx-2">
                  <v-btn
                    v-if="!resettingPassword"
                    class="mb-2"
                    color="primary"
                    block
                    type="submit"
                    :disabled="!isValid"
                  >
                    Reset
                  </v-btn>
                  <v-btn v-else color="primary" block type="submit" disabled>
                    <v-progress-circular indeterminate color="primary" />
                  </v-btn>
                </v-card-actions>
              </v-form>

              <v-alert v-else outlined :color="'error'" :icon="'mdi-alert'" class="mx-2 mt-2">
                Invalid user credentials, please make sure they are correct.
              </v-alert>

              <v-alert
                v-if="messageReset"
                outlined
                :color="successfullReset ? 'success' : 'error'"
                :icon="successfullReset ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
                class="mx-2 mt-2"
              >
                {{ messageReset }}
              </v-alert>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthDataService from '@/services/AuthDataService';

export default {
  name: 'ResetPassword',
  data() {
    return {
      token: null,
      password: '',
      confirmPassword: '',
      valid: false,
      passwordRules: {
        required: (v) => !!v || 'Required field',
        minLength: (v) => v.length > 7 || 'Min. length 8 characters',
      },
      confirmPasswordRules: {
        required: (v) => !!v || 'Required field',
        passwordMatch: (v) => v === this.password || 'Passwords do not match',
      },
      messageReset: '',
      successfullReset: false,
      resettingPassword: false,
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    isValid() {
      return (
        this.password !== '' &&
        this.confirmPassword !== '' &&
        this.passwordRules.minLength(this.password) !== 'Min. length 8 characters' &&
        this.confirmPasswordRules.passwordMatch(this.confirmPassword) !== 'Passwords do not match'
      );
    },
  },
  mounted() {
    this.token = this.$route.query.token;
  },
  methods: {
    resetPassword() {
      this.messageReset = '';

      this.resettingPassword = true;

      AuthDataService.resetPassword(this.password, this.token).then(
        (response) => {
          if (response.status == 204) {
            this.successfullReset = true;
            this.messageReset =
              'Password successfully reset. You can now log in with your new password.';
            this.password = '';
            this.confirmPassword = '';
          } else {
            this.successfullReset = false;
            this.messageReset =
              'An error occurred while resetting password. Please, try again later.';
          }

          this.resettingPassword = false;
        },
        (error) => {
          this.successfullReset = false;
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response && error.response.status == 401) {
            if (error.response.data.code == 'INVALID_TOKEN') {
              this.messageReset = 'Invalid token. Please, check if the token is correct.';
            } else if (error.response.data.code == 'UNAUTHORIZED') {
              this.messageReset =
                'Token expired or invalid. Please, generate another one to reset your password.';
            } else {
              this.messageReset =
                'An error occurred while resseting password. Please, try again later.';
            }
          } else if (error.response && error.response.status == 404) {
            this.messageReset = 'User not found. Please, check if the token is correct.';
          } else if (error.response && error.response.status == 400) {
            if (error.response.data.code == 'VALIDATION_ERROR') {
              this.messageReset = 'Password is already in use. Please, use a new one.';
            } else {
              this.messageReset =
                'An error occurred while resetting password. Please, try again later.';
            }
          } else {
            this.messageReset =
              'An error occurred while resetting password. Please, try again later.';
          }

          this.resettingPassword = false;
        }
      );
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
  },
};
</script>
